// extracted by mini-css-extract-plugin
module.exports = {"formContain":"public-dataset-form-modal_formContain__mMB6n","defaultLabel":"public-dataset-form-modal_defaultLabel__1OJJb"};